import { useEffect } from 'react';
import { withLayout } from 'hocs';
import { Question } from '../Question/question';

const MoreQuestions = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div>
      <Question />
    </div>
  );
};

export default withLayout(MoreQuestions);
